import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgLockUnlocked = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.3749 8.0625C14.3749 6.50859 15.6335 5.25 17.1874 5.25C18.7413 5.25 19.9999 6.50859 19.9999 8.0625V9.75C19.9999 10.3723 20.5026 10.875 21.1249 10.875C21.7471 10.875 22.2498 10.3723 22.2498 9.75V8.0625C22.2498 5.26758 19.9823 3 17.1874 3C14.3925 3 12.1249 5.26758 12.1249 8.0625V9.75H4.24998C3.00898 9.75 2 10.759 2 12V18.75C2 19.991 3.00898 21 4.24998 21H15.4999C16.7409 21 17.7499 19.991 17.7499 18.75V12C17.7499 10.759 16.7409 9.75 15.4999 9.75H14.3749V8.0625Z", fill: props.fill }));
});
export default SvgLockUnlocked;
